import { PAUSE_NEWS_TICKER, RESUME_NEWS_TICKER } from './types'

export const pauseNewsTicker = (): { type: typeof PAUSE_NEWS_TICKER } => ({
  type: PAUSE_NEWS_TICKER
})

export const resumeNewsTicker = (): { type: typeof RESUME_NEWS_TICKER } => ({
  type: RESUME_NEWS_TICKER
})
